import { render, staticRenderFns } from "./mobileEditPlateRecord.vue?vue&type=template&id=66030b1c&scoped=true&"
import script from "./mobileEditPlateRecord.vue?vue&type=script&lang=js&"
export * from "./mobileEditPlateRecord.vue?vue&type=script&lang=js&"
import style0 from "./mobileEditPlateRecord.vue?vue&type=style&index=0&id=66030b1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66030b1c",
  null
  
)

export default component.exports